var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_vm._v(" 页面正在加载中，请稍等... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }